export default {
  /**邀请返佣首页 start */
  inviToReback: "커미션 반환 요청",
  accumuRewrds: "누적된 보너스를 받았습니다.",
  completedTranscation:
    "친구가 1수 이상의 영구 계약 거래 완료 시, 10USDT의 추가 증정금을 받을 수 있습니다.",
  inviteQuick: "좋은 기회가 기다리고 있으니 빨리 행동하십시오.",
  currWeekRank: "이번주 순위",
  weekRank: "차트 순위",
  inviteNum: "초대 인수",
  rebackAmount: "캐시백 금액",
  checkAllRanks: "차트 전체 보기",
  rebackRegu: "보너스 규칙",
  rebaRegu1:
    "친구가 처음으로 충전한 후, 사용자는 60일 안에 거래 총액 25%의 수수료를 캐시백으로 받을 수 있습니다. 주: 친구 한 명당 최대 500USDT의 캐시백 보유 가능, 초대 친구 많을수록 캐시백 사한이 없습니다.",
  rebaRegu2:
    "2중 보너스: 친구가 1수의 BTC 영구계약 체결 후 10USDT의 추가 보너스를 받을 수 있습니다.",
  shareOnce: "한 버튼으로 공유하기",
  myBill: "나의 포스터",
  shareToFace: "QR코드 공",
  myShareQrCode: "나의 초대 QR코드",
  sharOnceTitle: "친구 {phone}이/가 초대를 보냈습니다.",
  sharOnceText:
    "“BTCC 가입 시 5USDT의 증정금 무료 주는 이벤트에 참여 부탁드립니다.",
  shareActiveRegu: "이벤트 규칙",
  shareActiveTime: "이벤트 시간 :장시간 유효 이벤트 대상: 실제 사용자;",
  shareActiveSpire: "보상 유효 기간 :초청받은 사람은 60일 내 활성화;",
  shareActiveReward:
    "거래 이윤 반환: 보상 유효 기간 내 초청받은 사람이 계좌를 개설해 거래 활성화 시 추천인은 해당 거래의 반환되는 USDT를 얻습니다;",
  shareActiveTip:
    "주의: 친구 1명을 초청해 거래할 경우 최대 500USDT까지 반환됩니다. 초청이 많을수록 많이 가져갈 수 있어요.",
  shareActiveAtten: "주의사항:",
  shareAtiveRegu1:
    "초청받은 사람이 추천인의 개인 추천 링크(또는 QR코드)를 통해 계좌 개설을 하지 않을 경우, 유효 추천으로 간주되지 않아 고객 추천 증정금을 받을 수 없습니다. 실제 사용자는 개인 추천 링크(또는 QR 코드)에서만 생성할 수 있습니다;",
  shareAtiveRegu2:
    "거래 수 계산: 초청받은 사람이 활성화 후 60일 이내 모든 청산 수;",
  shareAtiveRegu3:
    "캐시백은 영업일에(월-금) 계산하여 일괄 지급됩니다. 휴일일 경우 그다음 영업일에 지급이 됩니다.",
  shareAtiveRegu4:
    "이벤트 기간 중 사용자의 불정당한 거래 혹은 규칙에 위반한 거래가 발견될 경우, 본사는 사용자 거래를 중단하고 장려금 자격을 취소하는 동시에, 문책권한을 보류할 수 있습니다;",
  shareAtiveRegu5:
    "본 회사는 본 약관의 최종 해석권 및 해당 혜택에 대한 수정 또는 정지 권리를 보유하고 있으며, 사전 통지할 필요가 없습니다.",
  /**邀请返佣首页 end */
  /**邀请记录，返佣记录 start */

  inviteReocrd: "초대 기록",
  rebackRecord: "커미션 기록",
  invitedAccount: "초청받은 사용자 계정",
  inviteTime: "초청 시간",
  status: "상태",
  checkMore: "더 보기 확인",
  noRecord: "기록이 없습니다!",
  type: "유형",
  rebaNum: "캐시백 금액",
  activited: "활성화 완료",
  notActive: "미활성화",
  /**邀请记录，返佣记录 end */
  /**排行榜 start */

  rankList: "차트",
  yourCurrWeekData: "귀하의 이번주 데이터",
  billboard: "차트",
  phone: "휴대폰 번호",
  cumulateReback: "누적 캐시백",
  noData: "데이터가 없습니다.",
  /**排行榜 end */
  /**账户等级 start */

  account: "계정",
  accountLevel: "계정 등급",
  miniAccount: "미니 계정",
  stdAccount: "표준 계정",
  vipAccount: "VIP 계정",
  stdFeeCut: "수수료 6.66% 인하",
  vipFeeCut: "수수료 20% 대폭 인하",
  currYouAre: "귀하는 현재",
  min: "미니 계정",
  std: "표준 계정",
  dia: "VIP 계정",
  superValueReco: "강력추천",
  invest: "충전（{unit}）",
  upgradeQuick: "즉시 업그레이드",
  moreGradeProfit:
    "앞으로 더 많은 계정 등급 혜택을 마련할 테니 많이 기대해 주세요.",
  konwAccountLevel: "계정등급 알아보기",
  whatsAccountLevel: "계정등급이란?",
  thisIsAccountLevel:
    "입금하신 UDST의 누적 금액에 따라 고객센터로 연락하여 계정 등급을 업그레이드하시기 바랍니다. USDT의 누적 입금 금액이 높을수록 계정의 등급도 높아지게 됩니다. 수수료의 부담이 적어지면 투자 원가를 절감할 수 있습니다. 계정을 업그레이드하여 더 많은 혜택을 받아보세요.",
  whichAccountLevel: "계정등급의 구분이란?",
  accountLevelTypes: "BTCC 계정등급이 미니, 표준 및 VIP로 구분됩니다.",
  accountLevCondiAndProfit: "계정 등급 조건 및 권익",
  feeRate: "요율",
  level: "등급",
  deposit: "예금",
  profit: "권익",
  mini: "미니",
  noRights: "특권이 없습니다.",
  standard: "표준",
  stdFeeCuts: "요율 6.66% 인하",
  vipFeeCuts: "요율 20% 대폭 인하",
  moreCutToFees: "구체적인 요율 감면이 자금 요율을 참고하십시오.",
  example: "사례",
  exampleDetail:
    "'현가 BTC/USDT8000USDT로 수수료 계산, 사용자 누적거래 50수 BTC/USDT 영구계약의 경우'",
  noRecharge: "(할인이 없습니다.)",
  cut40: "(40USDT 대폭 인하)",
  cut120: "(120USDT 대폭 인하)",
  minGradeAtten: "즉시 업그레이드하면 더 많은 권익을 누릴 수 있습니다!",
  stdGradeAtten: "업그레이드 계속하면 더 많은 권익을 누릴 수 있습니다!",
  diaGradeAtten: "더 많은 혜택을 받기 위해 즉시 거래합시다!",
  /**账户等级 end */
  /**账户升级start */

  appliUpgrade: "업그레이드 신청",
  accountNumber: "계좌번호",
  upgradeTo: "업그레이드",
  submit: "제출 계정 업그레이드",
  upgradeNeedKnow: "계정 업그레이드에 관한 주의 사항",
  upgradeNeedKnow1:
    "1. 업그레이드 전에 선택하신 계정에는 매수 포지션과 지정가 주문이 없는지 반드시 확인해 주세요.",
  upgradeNeedKnow2:
    "2. 고객서비스에서는 요청하신 다음 근무일 정오까지 승인 처리하겠습니다.",
  upgradeNeedKnow3:
    "3. 승인 후 다시 로그인하면 더 나은 투자 체험을 하실 수 있습니다.",
  accountUpgrade: "계정 업그레이드",
  applyPno: "신청 제출 완료 （신청 번호：{pno}）",
  applyNumber: "귀하의 BTCC계정:",
  applyFrom: "신청",
  applyTo: "계정이 업그레이드되었습니다.",
  applyResTime:
    "해당 서비스센터 직원은 요청하신 다음 근무일 정오까지 승인 처리하겠습니다.",
  /**账户升级end */

  accountNoDot: "계정",
  bonus: "증정금",
  cashBack: "캐시백",

  // 邀请返佣
  inviteHasInvitedUser: "초대된 사용자",
  inviteCumulativeBack: "누적 캐시백 금액(USDT)",
  inviteFriend: "친구 초대",
  inviteFriendDesc:
    "함께 BTCC에 가입하고 매일 행운의 룰렛 보너스 추첨권을 받아보세요. BTCC 리워드/보너스 코너에서 최대 1비트코인 경품이 당신을 기다립니다. 제 추천 코드로 지금 가입해 보세요.",
  inviteMyInviteLink: "나의 초대 링크",
  inviteShareLink: "링크 공유",
  inviteCode: "초대코드:",
  inviteCopy: "복사",
  inviteNow: "지금 초대 하기",
  inviteToUser: "초대된 사용자",
  inviteMyReward: "나의 캐시백",
  inviteUser: "사용자",
  inviteRegisterTime: "가입 시간",
  inviteNoInvitePerson: "초대받은 사람 현재 없음",
  inviteStartInvite: "초대 시작",
  inviteReward: "캐시백 금액(USDT)",
  inviteQRDesc: "BTCC 가입시 최고 500USDT 증정금 수령 가능",
  inviteQRJoin: "QR코드를 스캔하여 가입합니다",
  inviteCopySuccess: "복사 완료",
  inviteCopyError: "복사 실패",
  inviteFriendWin: "친구를 초대하여",
  inviteWinPercent: "25%",
  inviteBack: "캐시백 커미션을 받아보세요",
  inviteNoRecord: "기록이 없습니다.",
  inviteSlogan: "친구 초대하고 <strong>500USDT</strong> 보너스 받기",

  "您当前VIP等级,享受手续费折扣":
    "현재 VIP 등급: 현재 VIP등급은 <span class='{level}'></span>이며, 수수료 할인율은 <strong>{current}</strong>입니다. 업그레이드하여 <strong>{next}</strong> 할인을 받아보세요",
  VIP交易费率: "VIP 거래수수료",
  VIP等级: "VIP등급",
  账户资金: "계정 잔액",
  币币交易手续费: "코인 교환 수수료",
  合约交易手续费: "계약 거래 수수료",
  前往充值: "지금 업그레이드",
  前往充币: "지금 입금",
  充提币手续费: "입출금 수수료",
  币种: "코인 종류",
  充币费用: "입금 수수료",
  提币费用: "출금 수수료",
  最小提币数量: "최소 출금",
  最小充币数量: "최소 입금",
  折扣: "{amount} 할인",
  说明: "설명:",

  说明1:
    "BTCC VIP 프로그램의 VIP 레벨은 나열된 조건 사항에 따라 자동으로 업데이트됩니다. 다음은 VIP 레벨 업데이드 시간에대한 안내입니다.",
  说明2:
    "새로운 VIP 프로그램에서 사용자는 업그레이드 후 더 낮은 레벨로 다운되지 않습니다.",
  说明3: "각 주문과 결제의 거래 수수료는, 유저의 현재의 VIP 레벨에따라 발생합니다.",
  说明4: "BTCC의 거래 수수료는 Taker(테이커)와 Maker(메이커)를 구별하지 않습니다.",
  说明5: "상기 사항은 2023년 1월 10일 16:00 (한국 시간)부터 실행되었음을 알려드립니다.",
  vip权益全面升级: "새로워진 계정 혜택",
  生效时间: "유효 시점：2022/04/25 00:00:00 (UTC+8)",
  其他货币: "다른 코인",

  // 累计充值活动
  新手专享: "신규 가입자 단독 이벤트",
  广告标题: "신규 유저 한정 ",
  新手专享豪礼送: "상당 보너스 증정 이벤트",
  注册成功后等级赠金奖励:
    "BTCC에 가입 후 {day}일 내에 목표금액을 입금하여 해당 보너스를 받아보세요.",
  立即报名: "로그인하고 참여하기",
  如何领取奖励: "보너스 받는 방법",
  如何领取奖励第一步: "1.가입/로그인",
  如何领取奖励第二步: "2.목표금액 입금하기",
  如何领取奖励第三步: "3.보너스는 자동으로 계정에 적립됨",
  立即买币: "코인 구매하기",
  立即充币: "지금 입금하기",
  储值福利进度: "나의 보너스 진행 상황 ({coin} 입금)",
  充值升级提示:
    "나의 보너스 진행 상황<br />BTCC에 가입 후 {day}일 내에 목표액을 입금하시면 최대 17,500USDT까지 보너스를 받으실 수 있습니다.",
  活动举例: "이벤트 예시",
  有效充值: "입금",
  累计返利: "보너스누적(USDT) ",
  活动规则及条款: "이벤트 규정",
  活动版权: "이번 이벤트의 최종 해석권은 BTCC에게 있습니다. ",
  请联系客服: "추가 문의사항은 언제든지 고객센터로 연락 주시기 바랍니다.",
  报名成功: "신청 완료 ",
  充币提示: "코인 종류를 클릭하시면 입금 진행상황을 볼 수 있습니다.",
  我已了解: "네 알겠습니다",
  充值升级下一级:
    "<strong>{bonus}</strong> 보너스를 받았습니다 <br /><strong>{amount}</strong>를 추가 입금하여 다음 레벨의 보상을 받아보세요!",
  不符合新手报名条件: "죄송합니다. 귀하는 더 이상 이 이벤트에 참여 할 수 없습니다",
  前往福利中心参与其他活动:
    '다른 이벤트에 참여하려면 이벤트 페이지를 방문하세요.',

  我的赠金记录: "나의 보너스 기록",
  福利中心: "리워드/ 보너스",
  立即登录: "로그인하기",
  免费注册: "무료로 가입하기",
  "参与活动": "이벤트 참여",
  "立即参与": "지금 참여",
  "继续充值": "지금  입금",
  captcha_desc: "오른쪽으로 드래그",
  当前等级: "현재 레벨:",
  当前: "",
  参数: " ",
  兑换手续费减免: "코인 교환 수수료 할인",
  提币手续费减免: "출금 수수료 할인",
  月总成交量USD: "30일 거래량(USD)",
  账户资产USD: "총 계정 자산(USD)",
  账户资产: "총 계정 자산",
  继续升级: "등업하고 {amount} 할인을 즐겨보세요",
  gotIt: "이해했다",
  我的30日成交量: "30일 거래량",
  最近30天成交的交易合约: "이는 지난 30일 동안의 선물 거래량을 나타내며 USD로 계산됩니다.",
  我的资产: "총 계정 자산",
  昨日账户资产: "이는 USD로 계산된 계정 자산(모든 암호화폐 포함)*의 가치를 나타냅니다.<span>*매일 한국시간 1시에 업데이트됩니다.</span>",
  "title": "10일 거래 챌린지",
  "solgen": "챌린지를 완료하고 미스터리 박스를 받으세요. 최대 210USDT의 보너스를 받고 무료 거래 수수료를 즐기세요!",
  "super": "슈퍼 미스터리 박스",
  "super_award": "{min}-{max} USDT의 랜덤 보너스 받기",
  "supper_task": "7개의 미스터리 박스를 받은 후 수령 가능",
  "supper_tip": "먼저 데일리 챌린지를 완성하고 7개의 미스터리 박스를 획득하세요",
  "supper_open": "지금 개봉",
  "day": "진행 : {day} 일",
  "award_fee": "{min}-{max}%의 랜덤 거래 수수료 캐시백",
  "award_bouns": "{min}-{max} USDT 보너스",
  "task_complete": "<span>{reach}/{total}</span>의 거래 완료",
  "contract_task": "거래 챌린지",
  "task_need": "<span>{num}</span> 거래 완료",
  "get_award_fee": "{amount}% 거래 캐시백을 획득했습니다.",
  "get_award_bouns": "{amount}USDT 보너스 획득",
  "award_overdue": "만기됨",
  "award_hasget": "받은 보상",
  "award_toget": "지금 박스 개봉",
  "task_nostart": "사용 불가능",
  "task_ongoing": "챌린지 진행 중",
  "task_rules": "이벤트 세부정보",
  "task_rules_content1": "1. 참가 조건: 2022년 12월 23일 11:00:00(한국시간) 이후 VIP0 등급이면서 명시된 날짜와 시간 이후에 VIP 등급을 VIP1 이상으로 업그레이드한 유저만 이 두 가지 조건을 충족하면 자동으로 참가됩니다.",
  "task_rules_content1_desc":  "2022년 12월 23일 11:00:00(한국시간) 에 이미 VIP1~9가 된 유저는 이용하실 수 없습니다. ",
  "task_rules_content2":  "2. VIP1 이상으로 업그레이드되면 이벤트에 참여됩니다. 이 이벤트 페이지의 정보는 매일 06:00(한국시간)에 업데이트됩니다.",
  "task_rules_content3":  "3. 오늘의 미스터리 박스를 열기 위해서는 데일리 거래 도전을 완료해야 합니다. 매일 06:00(한국시간) 이전에 데일리 거래 도전을 완료하지 못하면 오늘의 미스터리 박스는 만료됩니다.하루 동안 완료한 거래 횟수는 매일 06:00(한국시간) 이후 자동으로 초기화되며, 이후 유저는 다음 데일리 거래 도전을 이용할 수 있습니다.",
  "task_rules_content4":  "4. 미스터리 박스에는 거래 현물과 보너스의 두 가지 유형의 보상이 있습니다.거래 캐시백: 거래 및 출금이 가능하며 미스터리 박스가 개봉되면 사용자의 계정에 자동으로 지급됩니다.보너스: 거래 수수료를 충당하는 데에만 사용할 수 있습니다. 수수료 보상 비율은 사용자의 VIP 등급에 따라 다릅니다.",
  "task_rules_content5":  "5. 거래 캐시백은 당일 완료해야 하는 거래 횟수에만 적용됩니다. 그 날의 거래 챌린지를 넘은 거래수는 캐쉬백의 대상이 되지 않습니다.",
  "task_rules_content6":  "6. 슈퍼 미스터리박스를 이용하려면 먼저 7일간의 거래 챌린지를 완료하고 7개의 미스터리 박스를 개봉해야 합니다. 이벤트가 종료되기 전에 챌린지를 완료하지 않으면 슈퍼 미스터리박스를 개봉할 수 없습니다.",
  "task_rules_content7":  "7. 미스터리 박스의 보상은 랜덤으로 지급됩니다.",
  "task_rules_content8":  "8. 미스테리 박스 개봉 후 보상은 사용자의 계정으로 자동 지급됩니다. 보상을 받지 못한 경우 고객센터에 문의하시기 바랍니다.",
  "task_rules_content9":  "9. 이벤트 기간 동안 비정상적인 활동으로 인해 계정이 제한된 경우 사용자는 미스터리 박스를 개봉할 수 없습니다.",
  "task_rules_content10":  "10. 이 이벤트에서 집계되는 거래에는 USDT 및 인버스 선물 포지션의 주문 및 청산이 포함됩니다.",
  "task_rules_content11":  "이용약관",
  "task_rules_content12":  "1. BTCC는 이벤트 기간중에 복수 계정의 등록, 팀워크에 의한 부정 등록 등 기타 부정 행위가 행해졌다고 판단한 경우, 관련 계정의 이벤트 참가 자격을 무효로 할 권리가 있습니다.",
  "task_rules_content13":  "2. BTCC는 본 이벤트와 그 규정과 조건을 수시로 수정, 일시정지, 종료할 권리가 있습니다.",
  "task_rules_content14":  "3. BTCC는 본 이벤트를 해석할 권리를 보유합니다. 질문이 있으시면 고객센터에 문의하시기 바랍니다.",
  "complete_task": "<span>{num}</span>개 거래 완료",
  "no_standard": "챌린지를 아직 완료하지 않았습니다. 현재{num}개 완료되었습니다."
};



// WEBPACK FOOTER //
// ./src/locales/ko-KR.js